import React, { useEffect, useCallback } from 'react';
import './AlertOverlay.scss';
import { useSelector, useDispatch } from 'react-redux';
import { selectAlertOverlayData, clearAlert } from '../../../redux/overlaySlice';
import { showGameBasicsAlert, endTutorial } from '../../../redux/tutorialSlice';


export default function AlertOverlay(props) {
  const alertOverlayData = useSelector(selectAlertOverlayData);
  const dispatch = useDispatch();

  const checkExitOverlay = useCallback((ev) => {
    ev.stopPropagation();
    // Check if hitting ESC
    if (ev.keyCode === 27) {
      dispatch(clearAlert());
    }
  }, [dispatch]);

  useEffect(() => {
    if (!alertOverlayData || alertOverlayData.canEsc === false) {
      return;
    }

    document.addEventListener("keydown", checkExitOverlay);
    return () => document.removeEventListener("keydown", checkExitOverlay)
  }, [alertOverlayData, checkExitOverlay]);

  if (!alertOverlayData) {
    return null;
  }

  let textShown = "";
  if (Array.isArray(alertOverlayData.alertText)) {
    let list = [];
    for (let [idx, element] of alertOverlayData.alertText.entries()) {
      list.push(<li key={idx}>{element}</li>);
    }

    textShown = <ul>{list}</ul>;
  }
  else if (alertOverlayData.alertText instanceof String) {
    // Interpolate
    let alertParts = alertOverlayData.alertText.split(/\n/);
    for (let i = 1; i < alertParts.length; ++i) {
      alertParts[i] = <span key={i}><br />{alertParts[i]}</span>;
    }

    textShown = alertParts;
  } else {
    textShown = alertOverlayData.alertText;
  }

  let actionButtons = [];
  if (alertOverlayData.alertButtons && alertOverlayData.alertButtons.length > 0) {
    for (let [idx, button] of alertOverlayData.alertButtons.entries()) {
      const content = button.widthPX > 0
        ? <span className="button-content-fixed-width" style={{ width: ((button.widthPX - 30) + 'px') }}>{button.content}</span>
        : button.content;

      // Always add clearAlert to the button actions (we always want buttons to close the alert)
      let dispatchableEvents = [clearAlert()];
      if (Array.isArray(button.action)) {
        dispatchableEvents.push(...button.action);
      } else if (typeof button.action === "string") {
        // Can't serialize some events through redux :(
        switch (button.action) {
          case 'showGameBasicsAlert':
            dispatchableEvents.push(showGameBasicsAlert());
            break;

          case 'endTutorial':
            dispatchableEvents.push(endTutorial());
            break;

          default:
            break;
        }
      } else if (button.action) {
        dispatchableEvents.push(button.action);
      }

      actionButtons.push(
        <button
          key={idx}
          type="submit"
          className="button"
          onClick={() => dispatchableEvents.map((action) => dispatch(action))}
        >{content}</button>
      );
    }
  }

  return <div id="alert-overlay" className={`overlay-background dark-background-overlay ${alertOverlayData.canEsc ? 'esc-overlay' : ''}`}>
    <div className="overlay-wrapper">
      {alertOverlayData.canEsc ? <i className="fas fa-times" onClick={() => dispatch(clearAlert())}></i> : ''}
      <div id="alert-overlay-image" className={`rey-${alertOverlayData.alertType}`}></div>
      <div id="circle-behind-alert-overlay-image"></div>
      <div id="alert-overlay-container">
        <div className="overlay-title">{alertOverlayData.alertTitle}</div>
        <div className="overlay-text-explanation">{textShown}</div>
        <div id="alert-overlay-action-buttons">
          {actionButtons}
        </div>
      </div>
    </div>
  </div>;
}
